const images = [
  "11_ognydx.jpg",
  "9_xdvwss.jpg",
  "7_usvywz.jpg",
  "8_w2cmha.jpg",
  "3_rsxch4.jpg",
  "6_ztz8wp.jpg",
  "5_xtexe8.jpg",
  "21_nz2j2u.jpg",
  "4_iqrtgg.jpg",
  "23_nhdosn.jpg",
  "22_scjqe8.jpg",
  "20_hqdqaj.jpg",
  "18_l4o6xt.jpg",
  "2_ikcmuh.jpg",
  "19_d8em3g.jpg",
  "17_aibz9s.jpg",
  "15_gyqdqo.jpg",
  "16_xzo0u3.jpg",
  "14_yvvkc7.jpg",
  "12_eikdtt.jpg",
  "1_vxzqgb.jpg",
  "13_zorxf5.jpg",
  "10_hb6xn0.jpg",
];

export default images;
